import { useEditEntityDrawer, UseEditEntityDrawerReturnType } from '../UseEditEntityDrawer';
import { EnrichedEventData, PrivateSlotOut, UnavailabilityData } from '../../../api';
import { CalendarSlot } from '../SlotActionsMenu/CalendarSlot';

export type ExperienceAvailabilityDrawerState = {
  isOpen: boolean;
  unavailability?: UnavailabilityData;
  privateSlotAvailability?: PrivateSlotOut;
  event?: EnrichedEventData;
  orderPageId?: string;
  // Opened from an empty calendar slot: a new availability/unavailability starts on the slot's date and time.
  slot?: CalendarSlot;
};

export const useExperienceAvailabilityDrawer = (): UseEditEntityDrawerReturnType<ExperienceAvailabilityDrawerState> => {
  return useEditEntityDrawer<ExperienceAvailabilityDrawerState>({ isOpen: false });
};
